export const passwordHelperText = (
  <>
    Must be 8 or more characters and contain at least 1 number <br />1 special
    character 1 uppercase and 1 lowercase letter.{" "}
  </>
);

export const plural = (number: number) => (number === 1 ? "" : "s");

export const getUserLocale = () =>
  navigator.languages?.length ? navigator.languages[0] : navigator.language;

export function truncateString(str: string | null, maxLength: number): string {
  if (!str) {
    return ""; // Return an empty string if the input is null
  }
  if (str.length <= maxLength) {
    return str; // Return the original string if it's within the max length
  }
  return `${str.slice(0, maxLength - 3)}...`; // Truncate and add ellipsis
}

export const formatNumber = (n: number) => {
  if (n - Math.floor(n) > 0) {
    if ((n * 100) % 100 > 0) {
      return n.toFixed(2);
    }
    return n.toFixed(1);
  }
  return n;
};
